import { useState } from "react";
import { Link } from "react-router";
import { TierBadge } from "../brand/TierBadge";
import { useAuth } from "../../auth/AuthContext";
import { ROUTES } from "../../lib/constants";

export function Navbar() {
  const { user, isAdmin } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-white/80 backdrop-blur-sm sticky top-0 z-50 relative">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to={ROUTES.HOME} className="inline-flex min-h-11 flex-col items-start justify-center no-underline">
          <img src="/assets/logo.svg" alt="wineapi.io" className="h-6 shrink-0" />
          <span className="text-xs text-terroir">Public beta</span>
        </Link>

        {/* Mobile hamburger */}
        <button
          className="md:hidden inline-flex min-h-11 min-w-11 items-center justify-center p-3 text-terroir hover:text-noir"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-controls="mobile-menu"
          aria-expanded={menuOpen}
        >
          {menuOpen ? (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-6">
          <Link to={ROUTES.DATA_COVERAGE} className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir no-underline">
            Data Coverage &amp; FAQ
          </Link>
          <a
            href={ROUTES.DOCS}
            className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir transition-colors no-underline"
          >
            API Docs
          </a>
          <Link
            to={ROUTES.MCP}
            className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir transition-colors no-underline"
          >
            MCP
          </Link>
          {user ? (
            <div className="flex items-center gap-3">
              <TierBadge tier={user.tier} />
              <Link
                to={ROUTES.DASHBOARD}
                className="inline-flex min-h-11 items-center text-sm font-medium text-barrel hover:text-garnet no-underline"
              >
                Dashboard
              </Link>
              {isAdmin && (
                <Link
                  to={ROUTES.ADMIN}
                  className="inline-flex min-h-11 items-center text-sm font-medium text-terroir hover:text-noir no-underline"
                >
                  Admin
                </Link>
              )}
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <Link
                to={ROUTES.LOGIN}
                className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir transition-colors no-underline"
              >
                Login
              </Link>
              <Link
                to={ROUTES.LOGIN}
                className="inline-flex min-h-11 items-center text-sm font-medium bg-barrel text-white px-4 py-3 rounded-md hover:bg-garnet transition-colors no-underline"
              >
                Get Started
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* Mobile menu */}
      <div
        id="mobile-menu"
        className="md:hidden absolute top-16 left-0 right-0 bg-white border-b border-terroir/10 px-6 py-4 space-y-1 z-50 shadow-sm"
        hidden={!menuOpen}
      >
          <Link
            to={ROUTES.DATA_COVERAGE}
            className="block min-h-11 text-sm text-terroir hover:text-noir py-3 no-underline"
            onClick={() => setMenuOpen(false)}
          >
            Data Coverage &amp; FAQ
          </Link>
          <a
            href={ROUTES.DOCS}
            className="block min-h-11 text-sm text-terroir hover:text-noir py-3 no-underline"
            onClick={() => setMenuOpen(false)}
          >
            API Docs
          </a>
          <Link
            to={ROUTES.MCP}
            className="block min-h-11 text-sm text-terroir hover:text-noir py-3 no-underline"
            onClick={() => setMenuOpen(false)}
          >
            MCP
          </Link>
          {user ? (
            <>
              <div className="py-2.5">
                <TierBadge tier={user.tier} />
              </div>
              <Link
                to={ROUTES.DASHBOARD}
                className="block min-h-11 text-sm font-medium text-barrel hover:text-garnet py-3 no-underline"
                onClick={() => setMenuOpen(false)}
              >
                Dashboard
              </Link>
              {isAdmin && (
                <Link
                  to={ROUTES.ADMIN}
                  className="block min-h-11 text-sm font-medium text-terroir hover:text-noir py-3 no-underline"
                  onClick={() => setMenuOpen(false)}
                >
                  Admin
                </Link>
              )}
            </>
          ) : (
            <>
              <Link
                to={ROUTES.LOGIN}
                className="block min-h-11 text-sm text-terroir hover:text-noir py-3 no-underline"
                onClick={() => setMenuOpen(false)}
              >
                Login
              </Link>
              <Link
                to={ROUTES.LOGIN}
                className="block min-h-11 text-sm font-medium bg-barrel text-white px-4 py-3 rounded-md hover:bg-garnet transition-colors no-underline text-center mt-2"
                onClick={() => setMenuOpen(false)}
              >
                Get Started
              </Link>
            </>
          )}
      </div>
    </nav>
  );
}
